import React, { createContext, useEffect, useReducer } from "react";
import userReducer from "./userReducer";
import {
  current,
  getAccessToken,
  getIdToken,
  getRefreshToken,
} from "../shared/constants/login-store";
import _ from "lodash";
import { getService } from "../services/axios/services";

const initialContext = {
  me: {
    loading: true,
    user: null,
  },
  id: null,
  filter: {},
  current: null,
  list: {
    loading: true,
    result: [],
    pagination: {},
  },
};

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialContext);
  const [userIsAuthenticated, setUserIsAuthenticated] = React.useState(
    !_.isNull(current())
  );

  const currentIsActive = () => !_.isNull(current());

  const getRoles = () => {
    return getService({ endpoint: "users/me" }).then((res) => {
      dispatch({
        action: "setUser",
        key: "me",
        payload: res.data,
      });

      return res.data;
    });
  };

  const loadOrCreateUser = () => {
    return Promise.resolve();
  };

  const getFullName = (user) => {
    return !!currentIsActive()
      ? `${current().name || ""} ${current().lastName || ""}`
      : "Username";
  };

  const havePermission = (roles) =>
    _.difference(roles, state.me.user.sectionsAllowed);

  function hasPermission({ required }) {
    if (!state.me.user.sectionsAllowed?.length) return false;

    return required?.some((permission) =>
      state.me.user.sectionsAllowed.includes(permission)
    );
  }

  const userDontHavePermission = () =>
    state.me.user.sectionsAllowed?.length === 0;

  const userIsRole = (role) => state.me.user.roles?.includes(role);

  const userIsOnlyRole = (role) =>
    state.me.user.roles?.includes(role) && state.me.user.roles?.length === 1;

  const userIsNotMonoPermission = () =>
    state.me.user.sectionsAllowed?.length > 1;

  const idToken = getIdToken();
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();

  useEffect(() => {
    if (idToken && accessToken && refreshToken) {
      getRoles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentIsActive()) {
      setUserIsAuthenticated(currentIsActive());
    }
  }, []);

  return (
    <UserContext.Provider
      value={{
        ...state,
        loadOrCreateUser,
        currentIsActive,
        getFullName,
        havePermission,
        hasPermission,
        userDontHavePermission,
        userIsRole,
        userIsOnlyRole,
        userIsNotMonoPermission,
        getRoles,
        userIsAuthenticated,
        setUserIsAuthenticated,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext as default, UserProvider };
